module.exports = __webpack_public_path__ + "img/2022-21.20bba6d0.jpg";